"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = noPOBox;
var PO_REGEX = /\b(((p[\s.]?[o\s][.]?)\s?)(st(\s?)office)?(\s)?(b|box|bin|num|number|\d))/i; // Only reject the address if it is followed by the word "box", "number" or a number
// Example:
//   - ✔ 14 Po Street
//   - ✖ PO box 14
//   - ✖ PO number 14
//   - ✖ PO 14
// More test cases in the test file.

function noPOBox(value) {
  if (PO_REGEX.test(value)) {
    return {
      message: 'validation.noPOBox'
    };
  }

  return null;
}